<template>
    <div class="tab_content">
        <span class="tab_content-title">{{ $t('editorTabFrameTitle') }}</span>
        <div class="image_cells tab_grid">
            <div
                class="image_cells-item"
                v-for="(cell, index) in shapes"
                :key="index"
                :style="`clip-path:${cell.path}; -webkit-clip-path:${cell.path};`"
                @click="addElement(cell)"
            >
                <div
                    class="image_cells-item-border"
                    :style="`clip-path:${cell.path}; -webkit-clip-path:${cell.path};`"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { uuid } from 'vue-uuid';
    import photoCellItem from './photoCellItem.vue';

    export default {
        data() {
            return {
                shapes: [
                    {
                        name: 'square',
                        path: 'inset(0 0 0 0)'
                    },
                    {
                        name: 'circle',
                        path: 'circle(50% at 50% 50%)'
                    },
                    {
                        name: 'ellipse',
                        path: 'ellipse(35% 50% at 50% 50%)'
                    },
                    {
                        name: 'triangle',
                        path: 'polygon(50% 0%, 0% 100%, 100% 100%)'
                    },
                    {
                        name: 'pentagon',
                        path: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)'
                    },
                    {
                        name: 'hexagon',
                        path: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)'
                    },
                    {
                        name: 'heptagon',
                        path: 'polygon(50% 0%, 90% 20%, 100% 60%, 75% 100%, 25% 100%, 0% 60%, 10% 20%)'
                    },
                    {
                        name: 'octagon',
                        path: 'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)'
                    },
                    {
                        name: 'nonagon',
                        path: 'polygon(50% 0%, 83% 12%, 100% 43%, 94% 78%, 68% 100%, 32% 100%, 6% 78%, 0% 43%, 17% 12%)'
                    },
                    {
                        name: 'decagon',
                        path: 'polygon(50% 0%, 80% 10%, 100% 35%, 100% 70%, 80% 90%, 50% 100%, 20% 90%, 0% 70%, 0% 35%, 20% 10%)'
                    }
                ],
                cells: [
                    {
                        name: 'square',
                        path: 'm -24.642857,0.17857143 h 100 V 100.17857 h -100 z'
                    },
                    {
                        name: 'circle',
                        path: 'M 75,50 A 50,50 0 0 1 25,100 50,50 0 0 1 -25,50 50,50 0 0 1 25,0 50,50 0 0 1 75,50 Z'
                    },
                    {
                        name: 'ellipse',
                        path: 'M 49.517853,49.958332 A 24.401783,49.464287 0 0 1 25.116069,99.422626 24.401783,49.464287 0 0 1 0.71428571,49.958332 24.401783,49.464287 0 0 1 25.116069,0.49404532 24.401783,49.464287 0 0 1 49.517853,49.958332 Z'
                    },
                    {
                        name: 'triangle',
                        path: 'M 75,94.651519 H 25.000001 -25 L 9.9999998e-8,50.000001 25.000001,5.3484811 50,49.999999 Z'
                    },
                    {
                        name: 'pentagon',
                        path: 'M 55.737586,99.999998 -6.0658124,99.885618 -25,38.082212 25.101427,2.49e-6 75,38.267302 Z'
                    },
                    {
                        name: 'hexagon',
                        path: 'M 24.999995,100 -25,75.000001 v -50 L 24.999995,0 75,25.000001 v 50 z'
                    },
                    {
                        name: 'heptagon',
                        path: 'M 74.999998,64.24955 47.284203,99.957883 2.7800191,100 -25,64.34419 -15.136929,19.840004 24.942136,0 65.056845,19.764108 Z'
                    },
                    {
                        name: 'octagon',
                        path: 'M 74.925405,70.785271 45.605187,99.999998 4.2147295,99.925405 -24.999998,70.605187 -24.925405,29.214729 4.3948131,1.5980607e-6 45.785271,0.07459466 74.999998,29.394813 Z'
                    },
                    {
                        name: 'nonagon',
                        path: 'M 68.969247,77.331836 42.364814,99.999997 H 7.6351862 L -18.969273,77.331836 -25,42.602202 -7.6351862,12.061472 25,-3e-6 57.635186,12.061472 75,42.602202 Z'
                    },
                    {
                        name: 'decagon',
                        path: 'M 63.52557,82.22833 39.050445,100 8.8037268,99.991467 -15.661366,82.205988 -25,53.437013 -15.645134,24.673312 8.8299911,6.9016409 39.076709,6.9101746 63.541802,24.695653 72.880436,53.464629 Z'
                    }
                ]
            }
        },
        methods: {
            addElement(photoCell) {
                let newPhotoCellElement = {
                    id: uuid.v1(),
                    pageId: this.getActivePageId,
                    type: 'PHOTO_CELL_ELEMENT',
                    name: photoCell.name,
                    path: photoCell.path,
                    maskImg: {
                        src: null,
                        width: null,
                        height: null,
                        isFromSvg: false
                    },
                    height: 200,
                    width: 200,
                    endValues: {
                        width: 200,
                        height: 200,
                    },
                    webSizeMM: {
                        width: 200 * 0.084667,
                        height: 200 * 0.084667,
                        translate: [0 * 0.084667, 0 * 0.084667]
                    },
                    imageWebSizeMM: {
                        width: 200 * 0.084667,
                        height: 200 * 0.084667,
                        translate: [0 * 0.084667, 0 * 0.084667]
                    },
                    photoCellEndValues: {
                        width: 0,
                        height: 0,
                        left: 0,
                        top: 0,
                        rotate: 0,
                        scaleX: 1,
                        scaleY: 1,
                        transform: null
                    },
                    frame: {
                        translate: [0, 0],
                        scale: [1, 1],
                        rotate: 0
                    },
                    imageFrame: {
                        translate: [0, 0],
                        scale: [1, 1],
                        rotate: 0
                    },
                    photoCellImageIsEdited: false,
                    filters: {
                        blur: {
                            value: 0
                        },
                        brightness: {
                            value: 100
                        },
                        contrast: {
                            value: 100
                        },
                        grayscale: {
                            value: 0
                        },
                        sepia: {
                            value: 0
                        }
                    },
                    isActive: true,
                    zIndex: this.getZIndex,
                    isLocked: false,
                    newTransforms: true
                }
                
                if (this.getSessionDetails.mode === 'user') {
                    if (this.getActivePage.content.isLocked === false) {
                        this.$store.dispatch('ADD_PAGE_ELEMENT', newPhotoCellElement);
                        this.$store.dispatch('CHANGE_TAB', 'ImageTab');
                    }
                } else {
                    this.$store.dispatch('ADD_PAGE_ELEMENT', newPhotoCellElement);
                    this.$store.dispatch('CHANGE_TAB', 'ImageTab');
                }
            }
        },
        computed: {
            ...mapGetters([
                'getZIndex',
                'getActivePageId',
                'getSessionDetails',
                'getActivePage'
            ])
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/setup/_variables.scss';

    .image_cells-item {
        width: 22%;
        padding-top: 22%;
        margin: 1.5%;
        background-color: white;
        position: relative;
        cursor: pointer;
    }
    @media (max-width: 1200px) {
        .image_cells-item {
            width: 40%;
            padding-top: 40%;
            margin: 10px auto;
        }
    }
    .image_cells-item-border {
        position: absolute;
        width: calc(100% - 4px);
        background-color: #8F6E9F;
        padding-top: calc(100% - 4px);
        margin: 2.5%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
    @media (max-width: 1200px) {
        .image_cells-item-border {
            width: calc(100% - 4px);
            padding-top: calc(100% - 4px);
            margin: 3%;
        }
        .image_cells  > div:nth-of-type(3) .image_cells-item-border {
            width: calc(100% - 5px);
            padding-top: calc(100% - 5px);
        }
    }
    .tab_content {
        height: 100%;
    }
    .tab_grid {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        height: 96%;
        overflow-y: auto;
        overflow-x: hidden;
        margin-top: $pd-s;
    }
</style>